import axios from 'axios';
import { config } from './../Configurator'
import { multiplyFields, convertDateForApi, getMultipleMainApplicant } from './../Utils'
import alertify from 'alertifyjs';

const endpoint = "UpdateCustomer";
const endpoint2 = "UpdateCase";

export const executeUpdateCustomer = (att, applicant_id, customer_reference) => {

    let main_applicant = getMultipleMainApplicant(att);
    
    let payload_1 = payload1(att, applicant_id, customer_reference);

    axios.post(config().base_url + endpoint, payload_1).then(function(response){


        let payload_2 = updateCasePayload(att, applicant_id, customer_reference);

        if(response.data.d.UpdateResult.SuccessCode==0) {

            axios.post(config().base_url + endpoint2, payload_2).then(function(response){

                if(response.data.d.UpdateResult.SuccessCode==0) {
                    window.location.href = "/case/" + applicant_id;
                } else {
                    alertify.confirm('Error', response.data.d.UpdateResult.Message, null, null);
                }

            }).catch(function (error){
                alertify.confirm('Error', error.message, null, null);
            });

        } else {
            alertify.confirm('Error', response.data.d.UpdateResult.Message, null, null);

        }
        }).catch(function (error){
            alertify.confirm('Error', error.message, null, null);
        });

}

const payload1 = (att, applicant_id, customer_reference) => {
    let main_applicant = getMultipleMainApplicant(att);
    return {
        "UserInfo": {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password')
        },
        "Customer": {
            "CustomerReference": customer_reference,
            "Firstname": main_applicant.Firstname,
            "Surname": main_applicant.Surname,
            "Firstname2": null,
            "Surname2": null,
            "Email": main_applicant.email,
            "Telephone": main_applicant.telephone,
            "Mobile": main_applicant.mobile,
            "CustomerStatus": 'Prospect',
            // "B2BCustomer": "true",
            "IsUpdateCaseCustomer":true,
            "DateOfBirth": convertDateForApi(att.mc1_DateOfBirth__0),
            "InvoiceTermName": "",
            "CustomerAddress": {
                "HouseName": "",
                "HouseNumber": "",
                "Address1": main_applicant.address1,
                "Address2": main_applicant.address2,
                "Address3": main_applicant.address3,
                "Address4": main_applicant.address4,
                "PostCode": main_applicant.postcode
            },
            "CompanyAddress": {
                "address1": att.compAddress1,
                "address2": att.compAddress2,
                "address3": att.compAddress3,
                "address4": att.compAddress4,
                "postcode": att.compPostcode
            },
            "MultiContacts": multiplyFields(att, {
                "CustomFields": [{
                    "CustomFieldNo": 1,
                    "CustomFieldValue": 'att.mc1_CustomFieldValue1'
                },
                {
                    "CustomFieldNo": 2,
                    "CustomFieldValue": 'att.mc1_CustomFieldValue2'
                },
                {
                    "CustomFieldNo": 3,
                    "CustomFieldValue": 'att.mc1_CustomFieldValue3'
                },
                {
                    "CustomFieldNo": 5,
                    "CustomFieldValue": 'att.mc1_MainApp'
                },
                {
                    "CustomFieldNo": 6,
                    "CustomFieldValue": 'att.mc1_CustomFieldValue6'
                }
                ],
                "Firstname": 'att.mc1_Firstname',
                "Surname": 'att.mc1_Surname',
                "Guarantor": 'att.Guarantors',
                "IncludeInPIP": 'att.mc1_IncludeInPIP',
                "Address1": 'att.mc1_address1',
                "Address2": 'att.mc1_address2',
                "Address3": 'att.mc1_address3',
                "Address4": 'att.mc1_address4',
                "ForceDelete": 'att.mc1_ForceDelete',
                "PostCode": 'att.mc1_postcode',
                "DirectPhone": 'att.mc1_telephone',
                "Mobile": 'att.mc1_mobile',
                "Email": 'att.mc1_email',
                "Position": 'att.mc1_position',
                "DateOfBirth": 'att.mc1_DateOfBirth'
            },

            )
                }
    }
}

const updateCasePayload = (att, applicant_id, customer_reference) => {
    let ret = {
        "UserInfo": {
            "Username": localStorage.getItem('bo_email'),
            "Password": localStorage.getItem('bo_password')
        },
        "CaseApp": {
            "ApplicantID": applicant_id,
            "CustomerReference": customer_reference,
            "AvoidUpdatingBlankData":true,
            "MainApplicant": {
                "Title": '',
                "Firstname": '',
                "Surname": '',
                "DateOfBirth": convertDateForApi(""),
                "Telephone": '',
                "WorkTelephone": '',
                "Mobile": '',
                "EmailAddress": '',
                "BankDetail": [{
                    "BankName": att.bank_name,
                    "AccountName": att.account_name,
                    "AccountNumber": att.account_number,
                    "SortCode": att.sort_code
                }],
                "CurrentAddress": {
                    "HouseName": '',
                    "HouseNumber": '',
                    "Address1": '',
                    "Address2": '',
                    "Address3": '',
                    "Address4": '',
                    "PostCode": ''
                },
                "PreviousAddresses": {},
                "App2ID": 0
            },
            "AdditionalApplicants": [
                {
                    "Title": "",
                    "Firstname": att.mc1_Firstname__1,
                    "Surname": att.mc1_Surname__1,
                    "DateOfBirth": att.mc1_DateOfBirth__1,
                    "Telephone": att.mc1_telephone__1,
                    "WorkTelephone": att.mc1_telephone__1,
                    "Mobile": att.mc1_mobile__1,
                    "EmailAddress": att.mc1_email__1,
                    "CurrentAddress": {
                        "HouseName": "",
                        "HouseNumber": "",
                        "Address1": att.mc1_address1__1,
                        "Address2": att.mc1_address2__1,
                        "Address3": att.mc1_address3__1,
                        "Address4": att.mc1_address4__1,
                        "PostCode": att.mc1_postcode__1
                    },
                },
                {
                    "Title": "",
                    "Firstname": att.mc1_Firstname__2,
                    "Surname": att.mc1_Surname__2,
                    "DateOfBirth": att.mc1_DateOfBirth__2,
                    "Telephone": att.mc1_telephone__2,
                    "WorkTelephone": att.mc1_telephone__2,
                    "Mobile": att.mc1_mobile__2,
                    "EmailAddress": att.mc1_email__2,
                    "CurrentAddress": {
                        "HouseName": "",
                        "HouseNumber": "",
                        "Address1": att.mc1_address1__2,
                        "Address2": att.mc1_address2__2,
                        "Address3": att.mc1_address3__2,
                        "Address4": att.mc1_address4__2,
                        "PostCode": att.mc1_postcode__2
                    },
                },
                {
                    "Title": "",
                    "Firstname": att.mc1_Firstname__3,
                    "Surname": att.mc1_Surname__3,
                    "DateOfBirth": att.mc1_DateOfBirth__3,
                    "Telephone": att.mc1_telephone__3,
                    "WorkTelephone": att.mc1_telephone__3,
                    "Mobile": att.mc1_mobile__3,
                    "EmailAddress": att.mc1_email__3,
                    "CurrentAddress": {
                        "HouseName": "",
                        "HouseNumber": "",
                        "Address1": att.mc1_address1__3,
                        "Address2": att.mc1_address2__3,
                        "Address3": att.mc1_address3__3,
                        "Address4": att.mc1_address4__3,
                        "PostCode": att.mc1_postcode__3
                    },
                },
                {
                    "Title": "",
                    "Firstname": att.mc1_Firstname__4,
                    "Surname": att.mc1_Surname__4,
                    "DateOfBirth": att.mc1_DateOfBirth__4,
                    "Telephone": att.mc1_telephone__4,
                    "WorkTelephone": att.mc1_telephone__4,
                    "Mobile": att.mc1_mobile__4,
                    "EmailAddress": att.mc1_email__4,
                    "CurrentAddress": {
                        "HouseName": "",
                        "HouseNumber": "",
                        "Address1": att.mc1_address1__4,
                        "Address2": att.mc1_address2__4,
                        "Address3": att.mc1_address3__4,
                        "Address4": att.mc1_address4__4,
                        "PostCode": att.mc1_postcode__4
                    },
                }
            ],
            "MatterType": '',
            "Provider": '',
            "ProviderDescription": '',
            "ProviderRef": '',
            "ProviderCaseRef": '',
            "OldCaseRef": '',
            "CreditType": '',
            "NetClaim": att.NetClaim ?? 0,
            "Commission": att.Commission ?? 0,
            "ClaimInterest": att.ClaimInterest ?? 0,
            "CustomerInitialFee": att.CustomerInitialFee ?? 0,
            "CustomerCompletionFeePerc": att.CustomerCompletionFeePerc,
            "CustomerCompletionFee": att.CustomerCompletionFee ?? 0,
            "CaseStatus": att.CaseStatus,
            "StatusDate": convertDateForApi("") ,
            "Source": att.Source,
            "SourceRef": '',
            "SourceAffiliate": '',
            "CaseAssignmentBranch": att.CaseAssignmentBranch,
            "DateCreated": convertDateForApi(""),
            //"UserCreated": null,
            "WorkflowStep": '',
            //"DaysOld": null,
            "CaseOwner": '',
            "CustomerOwner": '',
            "BrokerCode": '',
            "BrokerName": '',
            "BrokerReference": '',

            // 
            "CaseOwner": "",
            "CustomerOwner": "",
            "CaseUnderWriter": att.UnderWriter,
            "CaseProcessor": att.Processor,
            "CaseAdditionalUser1": att.AdditionalUser1,
            "CaseAdditionalUser2": "",


            "DynamicFieldDetail": [{
                "FieldNo": 1,
                "FieldValue": ""
            },
            {
                "FieldNo": 2,
                "FieldValue": att.purpose
            },
            {
                "FieldNo": 4,
                "FieldValue": att.dynamicData4
            },
            {
                "FieldNo": 5,
                "FieldValue": att.dynamicData5
            },
            {
                "FieldNo": 6,
                "FieldValue": att.dynamicData6
            },
            {
                "FieldNo": 8,
                "FieldValue": ""
            },
            {
                "FieldNo": 11,
                "FieldValue": ""
            },
            {
                "FieldNo": 12,
                "FieldValue": att.dynamicData12
            }
            ],

            
            "CaseNotesList": {
                "CaseNotes": {
                    "NoteType": '',
                    "ApplicantId": '',
                    "Notes": '',
                    "CreatedDate": convertDateForApi(''),
                    "CreatedBy": '',
                    "CreatedByName": '',
                    "Status": '',
                }
            }
        }
    }


    ret.CaseApp.SecurityAddress = [];
    // handle securities 
    for(let i=0; i<100; i++) {
        if(typeof att['SecuirtyCode__' + i] !=='undefined') {
            console.log(att['SecuirtyCode__' + i]);

            ret.CaseApp.SecurityAddress.push(
                {
                    "Code": att['SecuirtyCode__' + i],
                    "HouseName": '',
                    "HouseNumber": "",
                    "Address1": "",
                    "Address2": '',
                    "Address3": '',
                    "Address4": "",
                    "Postcode": "",
                    "CurrentValue": att['CurrentValue__' + i],
                    "SecuirtyType": att['secuirtyType__' + i],
                    "SecuritySubType": att['SecuritySubType__' + i],
                    "SecuirtyDetails": att['secuirtyDetails__' + i],
                    "SecuirtyCharge": null,
                    "SecuirtyChargeValue": att['SecuirtyChargeValue__' + i],
                    "SecuirtyChargeDate": convertDateForApi(''),
                    "SecuirtyEquityValue": att['SecuirtyEquityValue__' + i],
                    "SecuirtyLendingValue": att['SecuirtyLendingValue__' + i],
                    "SecuirtyPurchaseValue": 0,
                    "SecuirtyPurchaseDate": convertDateForApi(''),
                    "SecuirtyMortgageValue": 0,
                    "SecuirtyMarketValue": Number(att['security_multiplier__' + i]),
                    "SecurityTitleNumber": '',
                    "SecurityCustomField": [
                        {
                            "CustomFieldNo": "1",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "2",
                            "CustomFieldValue": ""
                        },
                        {
                            "CustomFieldNo": "5",
                            "CustomFieldValue": ""
                        }
                    ]
                }
             );
        }
    }
    return ret;
}

export default {
    executeUpdateCustomer
};
